export const PAGE_CONFIG = {
  "title": "Retention",
  "titleCN": "留存",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/retention/index",
  "defaultTab": "newUsers",
  "tabList": [
    {
      "id": "newUsers",
      "tabName": "New Users",
      "tabNameCN": "新进留存分析",
      "isHaveNotification": true,
      "notificationPath": "/retention/index/newUsers",
      "path": "/retention/index/newUsers",
      "logConfig": {
        "pageId": "200801",
        "pageName": "engaementRetentionNewUsers",
        "extInfo": "engaementRetentionNewUsers",
        "pagePath": "/retention/index/newUsers"
      },
      "filters": [
        {
          "name": "RetentionMobileFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "retention/index/newUsers",
          "componentList": [
            {
              "name": "RetentionChartContentCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "NightingaleLineChartCo",
                  "className": "",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/engagement/retention/linechart",
                      "iconList": [
                        "eyes",
                        "lineChart"
                      ],
                      "componentMetrics": [
                        {
                          "metricKey": "d1",
                          "reqMetricKey": "d1",
                          "enName": "D1",
                          "cnName": "D1留存",
                          "rangeEnName": "Average D1",
                          "rangeCnName": "平均D1留存",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d1"
                        },
                        {
                          "metricKey": "d2",
                          "reqMetricKey": "d2",
                          "enName": "D2",
                          "cnName": "D2留存",
                          "rangeEnName": "Average D2",
                          "rangeCnName": "平均D2留存",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d2"
                        },
                        {
                          "metricKey": "d3",
                          "reqMetricKey": "d3",
                          "enName": "D3",
                          "cnName": "D3留存",
                          "rangeEnName": "Average D3",
                          "rangeCnName": "平均D3留存",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d3"
                        },
                        {
                          "metricKey": "d7",
                          "reqMetricKey": "d7",
                          "enName": "D7",
                          "cnName": "D7留存",
                          "rangeEnName": "Average D7",
                          "rangeCnName": "平均D7留存",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d7"
                        }
                      ],
                      "title": "D1/2/3/7 Retention New Users",
                      "titleCN": "新进用户 D1留存/D2留存/D3留存/D7留存",
                      "isHaveTitle": true,
                      "isHaveSubTitle": true,
                      "enChartTooltipsName": "New Users Retention",
                      "cnChartTooltipsName": "新进用户留存"
                    }
                  },
                  "data": {
                    "tag": "new",
                    "timeTypeIsShowCom": [
                      "day"
                    ]
                  }
                }
              ]
            },
            {
              "name": "RetentionTableCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/engagement/retention/table",
                    "tableDownloadApi": "/api/v1/dashboard/pc/engagement/retention/table/download"
                  },
                  "componentMetrics": [
                    {
                      "enName": "New",
                      "cnName": "注册",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    }
                  ],
                  "keyDaysConfig": [
                    {
                      "value": 0,
                      "enName": "Key Days",
                      "cnName": "关键日"
                    },
                    {
                      "value": 30,
                      "enName": "1 ~ 30 Days",
                      "cnName": "1 ~ 30 日"
                    },
                    {
                      "value": 60,
                      "enName": "1 ~ 60 Days",
                      "cnName": "1 ~ 60 日"
                    },
                    {
                      "value": 90,
                      "enName": "1 ~ 90 Days",
                      "cnName": "1 ~ 90 日"
                    }
                  ],
                  "title": "Retention New Users",
                  "titleCN": "新进用户留存"
                }
              },
              "data": {
                "tag": "new",
                "retentionColumsNum": "1"
              }
            }
          ]
        }
      ]
    },
    {
      "id": "activeUsers",
      "tabName": "Active Users",
      "tabNameCN": "活跃留存分析",
      "isHaveNotification": true,
      "notificationPath": "/retention/index/activeUsers",
      "path": "/retention/index/activeUsers",
      "logConfig": {
        "pageId": "200802",
        "pageName": "engaementRetentionActiveUsers",
        "extInfo": "engaementRetentionActiveUsers",
        "pagePath": "/retention/index/activeUsers"
      },
      "filters": [
        {
          "name": "RetentionMobileFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "retention/index/activeUsers",
          "componentList": [
            {
              "name": "RetentionChartContentCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "NightingaleLineChartCo",
                  "className": "",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/engagement/retention/linechart",
                      "componentMetrics": [
                        {
                          "metricKey": "d1",
                          "reqMetricKey": "d1",
                          "enName": "D1",
                          "cnName": "D1留存",
                          "rangeEnName": "Average D1",
                          "rangeCnName": "平均D1留存",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d1"
                        },
                        {
                          "metricKey": "d2",
                          "reqMetricKey": "d2",
                          "enName": "D2",
                          "cnName": "D2留存",
                          "rangeEnName": "Average D2",
                          "rangeCnName": "平均D2留存",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d2"
                        },
                        {
                          "metricKey": "d3",
                          "reqMetricKey": "d3",
                          "enName": "D3",
                          "cnName": "D3留存",
                          "rangeEnName": "Average D3",
                          "rangeCnName": "平均D3留存",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d3"
                        },
                        {
                          "metricKey": "d7",
                          "reqMetricKey": "d7",
                          "enName": "D7",
                          "cnName": "D7留存",
                          "rangeEnName": "Average D7",
                          "rangeCnName": "平均7留",
                          "type": "percent",
                          "decimal": 2,
                          "avgResKey": "avg_d7"
                        }
                      ],
                      "iconList": [
                        "eyes",
                        "lineChart"
                      ],
                      "title": "D1/2/3/7 Retention Active Users",
                      "titleCN": "活跃用户 D1留存/D2留存/D3留存/D7留存",
                      "isHaveTitle": true,
                      "isHaveSubTitle": true,
                      "enChartTooltipsName": "Active Users Retention",
                      "cnChartTooltipsName": "活跃用户留存"
                    }
                  },
                  "data": {
                    "tag": "active",
                    "timeTypeIsShowCom": [
                      "day"
                    ]
                  }
                }
              ]
            },
            {
              "name": "RetentionTableCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/engagement/retention/table",
                    "tableDownloadApi": "/api/v1/dashboard/pc/engagement/retention/table/download"
                  },
                  "componentMetrics": [
                    {
                      "enName": "Active Users",
                      "cnName": "活跃用户",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    }
                  ],
                  "keyDaysConfig": [
                    {
                      "value": 0,
                      "enName": "Key Days",
                      "cnName": "关键日"
                    },
                    {
                      "value": 30,
                      "enName": "1 ~ 30 Days",
                      "cnName": "1 ~ 30 日"
                    },
                    {
                      "value": 60,
                      "enName": "1 ~ 60 Days",
                      "cnName": "1 ~ 60 日"
                    },
                    {
                      "value": 90,
                      "enName": "1 ~ 90 Days",
                      "cnName": "1 ~ 90 日"
                    }
                  ],
                  "title": "Retention Active Users",
                  "titleCN": "活跃用户留存"
                }
              },
              "data": {
                "tag": "active",
                "retentionColumsNum": "1"
              }
            }
          ]
        }
      ]
    }
  ]
};